import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { cssClass } from '~src/style';

const cssPrefix = 'SiteAdminDialog';
export const centerPosition = cssClass(cssPrefix, 'centerPosition', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  minHeight: 200
});


export const headerStyle: React.CSSProperties = {
  paddingLeft: 20,
  fontWeight: 'bold',
  border: `1px solid ${TabStyles.Colors.L6}`,
  textAlign: 'left',
  paddingTop: 5,
  paddingBottom: 5
};

export const valueStyle: React.CSSProperties = {
  paddingLeft: 20,
  fontWeight: 'normal',
  border: `1px solid ${TabStyles.Colors.L6}`,
  textAlign: 'left'
};

export const tableStyle: React.CSSProperties = {
  tableLayout: 'fixed',
  marginLeft: 8,
  marginRight: 10,
  borderCollapse: 'collapse',
  border: '1px',
  width: '100%'
};

export const emailValue: React.CSSProperties = {
  fontWeight: 'bold'
};

export const textStyle: React.CSSProperties = {
  marginLeft: 8,
  lineHeight: 3
};